import React from "react";
import PropTypes from "prop-types";
import { detect } from "detect-browser";
import { NavLink } from "react-router-dom";
import ActionBarOptionsCog from "./ActionBarOptionsCog";
import ActionBarTitle from "./ActionBarTitle";
import companyDataType from "./types/companyDataType";
import spinner from "../loaders/img/spinner-white.gif";
import {
  Wrapper,
  BackLink,
  MobileBackButton,
  Spinner,
} from "./styles/action-bar-styles";

const ActionBar = (props) => {
  const {
    capitalize,
    title,
    subtitle,
    mobileTitle,
    backLink,
    backLinkUrl: backLinkUrlProp,
    mobileBackButton,
    noMargin,
    loading,
    reactRouterBackButton,
    reactRouterLink,
    onClickAction,
    id,
    betaBadge,
    optionsCog,
    optionsCogData,
    fullWidth,
    childCompanyFilterTitleSuffix,
    companyData,
    setSelectedCompany,
    isRootParentEmployer,
    parentChildEnabled,
  } = props;
  const isIE = detect().name === "ie";

  let backLinkUrl =
    new URL(document.location).searchParams.get("back_to") || backLinkUrlProp;

  const handleMobileBackButton = () => {
    if (backLinkUrl) {
      window.location.href = backLinkUrl;
    } else {
      window.history.back();
    }
  };

  return (
    <Wrapper
      isIE={isIE}
      id="action-bar"
      noMargin={noMargin}
      fullWidth={fullWidth}
      capitalize={capitalize}
    >
      {reactRouterBackButton && (
        <NavLink
          id={id}
          to={reactRouterLink}
          onClick={() => onClickAction()}
          className="react-router-link"
        >
          <MobileBackButton className="react-router-button" />
        </NavLink>
      )}
      {mobileBackButton && (
        <MobileBackButton onClick={handleMobileBackButton} />
      )}
      {backLink && (
        <BackLink href={backLinkUrl} data-turbolinks="false" title="Back">
          {backLink}
        </BackLink>
      )}
      {loading ? (
        <Spinner src={spinner} alt="Loading" />
      ) : (
        <ActionBarTitle
          betaBadge={betaBadge}
          childCompanyFilterTitleSuffix={childCompanyFilterTitleSuffix}
          companyData={companyData}
          mobileTitle={mobileTitle}
          setSelectedCompany={setSelectedCompany}
          subtitle={subtitle}
          title={title}
          showChildCompanyFilter={parentChildEnabled && isRootParentEmployer}
        />
      )}
      {optionsCog && <ActionBarOptionsCog data={optionsCogData} />}
    </Wrapper>
  );
};

ActionBar.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  mobileTitle: PropTypes.string,
  id: PropTypes.string,
  backLink: PropTypes.string,
  backLinkUrl: PropTypes.string,
  mobileBackButton: PropTypes.bool,
  noMargin: PropTypes.bool,
  loading: PropTypes.bool,
  capitalize: PropTypes.bool,
  reactRouterBackButton: PropTypes.bool,
  reactRouterLink: PropTypes.string,
  onClickAction: PropTypes.func,
  betaBadge: PropTypes.bool,
  optionsCog: PropTypes.bool,
  optionsCogData: PropTypes.arrayOf(PropTypes.shape({})),
  fullWidth: PropTypes.bool,
  childCompanyFilterTitleSuffix: PropTypes.string,
  companyData: companyDataType,
  setSelectedCompany: PropTypes.func,
  isRootParentEmployer: PropTypes.bool,
  parentChildEnabled: PropTypes.bool,
};

ActionBar.defaultProps = {
  title: PropTypes.isNull,
  id: PropTypes.isNull,
  subtitle: PropTypes.isNull,
  mobileTitle: PropTypes.isNull,
  backLink: PropTypes.isNull,
  backLinkUrl: PropTypes.isNull,
  mobileBackButton: PropTypes.isNull,
  noMargin: PropTypes.isNull,
  loading: PropTypes.isNull,
  capitalize: PropTypes.isNull,
  reactRouterBackButton: PropTypes.isNull,
  reactRouterLink: PropTypes.isNull,
  onClickAction: PropTypes.isNull,
  betaBadge: PropTypes.isNull,
  optionsCog: PropTypes.isNull,
  optionsCogData: PropTypes.isNull,
  fullWidth: false,
  childCompanyFilterTitleSuffix: "",
  companyData: PropTypes.isNull,
  isRootParentEmployer: false,
  parentChildEnabled: false,
  setSelectedCompany: () => {},
};

export default ActionBar;
